const colors = {
    primary: '#f48c00',
    primaryDark: '#F6A333',
    black: '#000',
    light: '#F1F2F3',
    white: '#fff',
    red: '#e60000',
    redD10: '#bd0000',
    redD20: '#b2120d',
    redD30: '#990000',
    purpleL10: '#97367e',
    purple: '#833472',
    purpleD10: '#5e2750',
    yellow: '#fecb00',
    yellowD10: '#c89700',
    orangeL10: '#ff9d00',
    orangeL20: '#F6A333',
    orange: '#eb9700',
    lightBlue: '#cceff4',
    blue: '#00b0ca',
    blueD10: '#007c92',
    greenL20: '#eef0ce',
    greenL10: '#a8b400',
    green: '#83a000',
    greenD10: '#428600',
    grayL40: '#f4f4f4',
    grayL30: '#ebebeb',
    grayL20: '#cccccc',
    grayL10: '#afafaf',
    gray: '#999999',
    grayD10: '#666666',
    grayD20: '#5b5b5b',
    grayD30: '#4a4d4e',
    grayD40: '#333333',
    gray100: '#F1F2F3',
    gray200: '#D7DADC',
    gray300: '#BCC1C5',
    gray400: '#A0A4A8',
    gray600: '#676A6C',
    gray900: '#1C1D1E',
    danger: '#D52B1E',
    warning: '#FFC107',
    success: '#498514',
};
export default colors;
//# sourceMappingURL=colors.js.map